// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__34kzw","grey":"layout_grey__31Aue","bodyClass":"layout_bodyClass__27Wth","hideHeader":"layout_hideHeader__27lg5"};